import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, Tooltip} from "@mui/material";
import MaterialEstimateUnitService
    from "../../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import ModalConfirm from "../../../../modal/ModalConfirm";
import EstimateService from "../../../../../../API/orders/estimate/organization/EstimateService";
import {Link, useNavigate} from "react-router-dom";
import CellMaterialReserveOptimizationQuantity from "./CellMaterialReserveOptimizationQuantity";
import ReplacementSimilarMaterials
    from "../../../../../../pages/organization/orders/estimate/ReplacementSimilarMaterials";
import MenuItem from "@mui/material/MenuItem";
import ButtonCreate from "../../../../button/ButtonCreate";
import ModalAddMaterial from "./ModalAddMaterial";
import ButtonSelectAction from "../../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../modal/ModalSelectAction";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import TextFieldValidation from "../../../customer-detales/TextFieldValidation";
import MaterialReserveService from "../../../../../../API/orders/reservation/MaterialReserveService";
import ModalWidthCheckbox from "../../../../modal/ModalWidthCheckbox";
import {
    ESTIMATE_GLOBAL_FILTER_FN,
    estimateFilterFns,
    estimateGetColumnCanGlobalFilter,
    filterEstimateRowsByGlobalSearch,
    getMaterialEstimateArticle,
    getMaterialEstimateName,
    getMaterialEstimateRequestsCuttingLabel,
    getMaterialEstimateUnitStateLabel,
    sortMaterialEstimateByCatalogArticle,
    sortMaterialEstimateByCatalogName,
    sortMaterialEstimateByRequestsCuttingNumber,
} from "../../../../../../utils/orders/estimateTableFilter";
import DetailUtil from "../../../../../../utils/cutting/DetailUtil";

const EstimateTableItem = ({
                               estimateId,
                               estimateState,
                               orderId,
                               orderNumber,
                               orderHeaderId,
                               year,
                               isButtonPurchase,
                               isActual,
                               enableEditing,
                               inWork,
                               isCloud,
                               isComposition,
                               isFact,
                               data,
                               setData,
                               isBlockedReplacement,
                               currency,
                               currentCurrency,
                               tableOptions,
                               tableOptionsHandle,
                               selectData,
                               handleModalAlert,
                               getData,
                               calcData,
                               errorIds
                           }) => {
    const navigate = useNavigate();
    const initValue = {material: {}, quantity: "", note: ""}
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [currentMaterialData, setCurrentMaterialData] = useState(null);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [rowSelection, setRowSelection] = useState([]);
    const [setPurchaseModalOpen, setSetPurchaseModalOpen] = useState(false);
    const [currentInWork, setCurrentInWork] = useState(inWork);
    const [searchSimilarMaterials, setSearchSimilarMaterials] = useState(false);
    const [showReservesModal, setShowReservesModal] = useState(false);
    const [materialModal, setMaterialModal] = useState(false);
    const [createReservesModalOpen, setCreateReservesModalOpen] = useState(false)
    const [openSelection, setOpenSelection] = useState(false)
    const availableAddReserve = data?.every(el => el.quantity > 0)
    const [openEdit, setOpenEdit] = useState(false)
    const [editModalData, setEditModalData] = useState({type: "", value: null})
    const [loading, setLoading] = useState(false)
    const [globalFilter, setGlobalFilter] = useState('')

    const filteredData = useMemo(
        () => filterEstimateRowsByGlobalSearch(data, globalFilter),
        [data, globalFilter],
    );

    const sumAmountBasePrice = useMemo(
        () => data.reduce((acc, mEU) => {
            if (mEU.costBasePrice && mEU.costBasePrice.price != null) {
                return acc + mEU.costBasePrice.price;
            }
            return acc;
        }, 0),
        [data]
    );

    const sumAmountAlternativePrice = useMemo(
        () => data.reduce((acc, mEU) => {
            if (mEU.costAlternativePrice && mEU.costAlternativePrice.price != null) {
                return acc + mEU.costAlternativePrice.price;
            }
            return acc;
        }, 0),
        [data]
    );

    const handleDeleteRow = useCallback(
        (row) => {
            const id = row.id;
            MaterialEstimateUnitService.delete(id)
                .then(function () {
                    setData(prev => prev.filter(el => el.id !== id));
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        },
        [data],
    );

    const handleSubmitSetPurchase = async (ignoreSlab, handleClose) => {
        setLoading(true)
        EstimateService.setPurchase(orderId, [], ignoreSlab)
            .then(function () {
                handleClose()
                setCurrentInWork(false);
                handleModalAlert("Заявка на закупку добавлена", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const handleCloseSetPurchase = () => {
        setSetPurchaseModalOpen(false);
    };

    const openSearchSimilarMaterials = useCallback(
        (row) => {
            setCurrentMaterialData(row.materialOrganizationOption);
            setCurrentEditRowData(row);
            setCurrentEditRowId(row.id)
            setSearchSimilarMaterials(true)
        },
        [],
    );

    const replacement = async () => {
        setLoading(true)
        const id = currentEditRowData.id
        const materialOrganizationOptionId = currentMaterialData.id
        MaterialEstimateUnitService.replacementByMaterialOrganizationOptionId(id, materialOrganizationOptionId)
            .then(function (response) {
                setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                setSearchSimilarMaterials(false);
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const handleReserveRow = (row) => {
        setCurrentEditRowId(row.id)
        setShowReservesModal(true)
    }
    const handleDeleteReserve = (row) => {
        setCurrentEditRowId(row.id)
        setShowReservesModal(true)
    }

    const closeShowReservesModal = () => {
        setShowReservesModal(false)
        setCurrentEditRowId(null)
        setRowSelection([])
        setOpenSelection(false)
    }
    const onCloseEditModal = () => {
        setOpenEdit(false)
        setEditModalData({type: "", value: null})
    }
    const handleEditNote = (row) => {
        setOpenEdit(true)
        setEditModalData({type: "note", value: row})
    }
    const handleEditQuantity = (row) => {
        setOpenEdit(true)
        setEditModalData({type: "quantity", value: row})
    }
    const onSubmitEditModal = (data) => {
        setLoading(true)
        const api = data.type === "note" ? MaterialEstimateUnitService.editNote(data.value.id, data.value.note) : MaterialEstimateUnitService.editQuantity(data.value.id, data.value.quantity)
        api.then(function (response) {
            onCloseEditModal()
            setData(prev => prev.map(el => el.id === data.value.id ? data.value : el))
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const handleShowReservesModal = async (all, action, ignoreSlab, handleClose) => {
        setLoading(true)
        if (action === 'delete') {
            MaterialEstimateUnitService.deleteByIds(rowSelection)
                .then(function (response) {
                    setData(prev => prev.filter(el => !rowSelection.includes(el.id)));
                    closeShowReservesModal()
                    handleModalAlert("Данные удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else if (action === 'deleteReserve') {
            MaterialEstimateUnitService.deleteReservesByIds(rowSelection).then(function (response) {
                closeShowReservesModal()
                const newData = data.map(el => response.data.find(respEl => respEl.id === el.id) || el)
                setData(newData)
                handleModalAlert("Резервы удалены", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else if (showReservesModal) {
            MaterialEstimateUnitService.deleteReserves(currentEditRowId)
                .then(function (response) {
                    const newData = data.map(el => el.id === currentEditRowId ? response.data : el)
                    calcData(newData)
                    closeShowReservesModal()
                    handleModalAlert("Резервы удалены", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else {
            EstimateService.createReserves(orderId, all ? {
                "ids": null
            } : {
                "ids": rowSelection
            }, estimateId, ignoreSlab)
                .then(function (response) {
                    getData()
                    all ? handleClose() : closeShowReservesModal()
                    if (isFact) {
                        navigate('/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + orderHeaderId + '/' + year);
                        navigate('/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + orderHeaderId + '/' + year + '/estimate/' + estimateId + "/" + "CREATED_RESERVES");
                    }
                    handleModalAlert("Резервы созданы", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }

    }
    const handleCloseMaterialModal = () => {
        setMaterialModal(false)
        setCurrentEditRowData(initValue)
        setCurrentEditRowId(null)
    }
    const handleSubmit = async (value, close) => {
        setLoading(true)
        MaterialEstimateUnitService.create(estimateId, value)
            .then(function (response) {
                setData(prev => [...prev, response.data])
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                close()
                handleModalAlert("Материал добавлен", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'articleNumber',
                header: 'Артикул',
                accessorFn: getMaterialEstimateArticle,
                sortingFn: sortMaterialEstimateByCatalogArticle,
                minSize: 250,
                Cell: ({row, renderedCellValue}) => {
                    const temp = row.original.materialOrganizationOption === null;
                    return <span
                        style={{
                            color: temp ? 'red' : 'black'
                        }}>
                               {renderedCellValue}
                            </span>
                }
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorFn: getMaterialEstimateName,
                sortingFn: sortMaterialEstimateByCatalogName,
                minSize: 550,
                Cell: ({row, renderedCellValue}) => {
                    const temp = row.original.materialOrganizationOption === null;
                    const link = temp ? renderedCellValue : <Link
                        to={'/organization/materials/' + row.original.materialOrganizationOption?.id + '/' + row.original.unit?.name + '/' + row.original.materialOrganizationOption?.typeMaterial + '/' + row.original.materialOrganizationOption?.materialId}>
                        {renderedCellValue}
                    </Link>
                    return (
                        <span
                            style={{
                                color: temp ? 'red' : 'black'
                            }}>
                           {link}
                           </span>
                    )
                }
            },
            {
                id: 'requestsCuttingNumber',
                header: 'Заявка',
                accessorFn: getMaterialEstimateRequestsCuttingLabel,
                sortingFn: sortMaterialEstimateByRequestsCuttingNumber,
                minSize: 15,
                maxSize: 15,
                Cell: ({row, renderedCellValue}) => {
                    const {materialOrganizationOption, requestsCutting} = row.original;

                    if (materialOrganizationOption === null) {
                        return '';
                    }

                    if (materialOrganizationOption.typeMaterial === 'SLAB') {
                        const nominalQuantity = requestsCutting ? requestsCutting.nominalQuantity.toFixed(3) : '';

                        return (
                            <Tooltip title={"В заявке на раскрой " + nominalQuantity + " кв. м"} arrow>
                                {requestsCutting === null ? (
                                    renderedCellValue
                                ) : (
                                    <Link
                                        to={`/organization/requests-cutting/details/${requestsCutting.id}/${encodeURIComponent(requestsCutting.number)}${isComposition ? `/composition?orderId=${orderId}` : isCloud ? "/cloud" : ""}`}>
                                        {renderedCellValue}
                                    </Link>
                                )}
                            </Tooltip>
                        );
                    }
                    return renderedCellValue;
                }
            },
            {
                id: 'unit',
                header: 'Ед. изм.',
                accessorFn: (row) => {
                    if (row.materialOrganizationOption !== null) {
                        return row.unit ? row.unit?.name : 'Нет данных';
                    } else {
                        return row.tempUnit ? row.tempUnit.name : 'Нет данных';
                    }
                },
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => <CellMaterialReserveOptimizationQuantity
                    value={cell.getValue()}
                    row={row}
                />
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 5,
                maxSize: 5,
                Cell: ({cell, row}) => {
                    const value = cell.getValue()
                    const temp = row.original.materialOrganizationOption === null;
                    const isSlab = temp ? row.original.quantity : row.original.materialOrganizationOption.typeMaterial === 'SLAB';
                    const currentValue = isSlab ? (value ? Number(value)?.toFixed(3) : 'Ожидание') : Number(value)?.toFixed(3);
                    const typeAndsIssue = isFact ? 'plan/true/' : 'calculation/false/'

                    const link = temp ? row.original.quantity : <Link
                        to={'/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/' + orderHeaderId
                            + '/' + year + '/estimates/' + estimateId + '/' + estimateState + "/" + isButtonPurchase + '/reservation/'
                            + row.original.id + '/' + isSlab + '/' + encodeURIComponent(row.original.materialOrganizationOption?.name)
                            + '/' + (encodeURIComponent(row.original.materialOrganizationOption?.articleNumber) || null) + '/' + typeAndsIssue + row.original.materialEstimateUnitState + "/" + row.original.unit?.name || row.original.tempUnit}>
                        {currentValue}
                    </Link>
                    return (
                        <span
                            style={{
                                color: temp ? 'red' : 'black'
                            }}>
                               {link}
                            </span>
                    );
                },

            },
            {
                header: 'Статус',
                id: 'materialEstimateUnitState',
                accessorFn: getMaterialEstimateUnitStateLabel,
                size: 150,
                filterFn: (row, id, filterValue) => {
                    return getMaterialEstimateUnitStateLabel(row.original)
                        .toLowerCase()
                        .includes((filterValue ?? '').toString().toLowerCase())
                },
            },
            {
                header: 'Заметки',
                accessorKey: 'note',
                size: 25,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
            },
        ];

        baseColumns.splice(6, 0, {
            id: 'reservePercentage',
            header: '% резерва',
            accessorKey: 'reservePercentage',
            minSize: 100,
        });
        baseColumns.splice(6, 0, {
            id: 'costAlternativePrice',
            header: `Стоимость в ${currency[1].value}`,
            accessorFn: (row) => row.costAlternativePrice?.price,
            minSize: 100,
            Cell: ({cell, row}) => {
                const value = cell.getValue();
                return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
            },
            Footer: () => (
                <Stack>
                    <Box color="warning.main">
                        {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        })} {currency[1].value}
                    </Box>
                </Stack>
            ),
        });

        baseColumns.splice(6, 0, {
            id: 'costBasePrice',
            header: `Стоимость в ${currency[0].value}`,
            accessorFn: (row) => row.costBasePrice?.price,
            minSize: 100,
            Cell: ({cell, row}) => {
                const value = cell.getValue();
                return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
            },
            Footer: () => (
                <Stack>
                    <Box color="warning.main">
                        {sumAmountBasePrice?.toLocaleString?.('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        })} {currency[0].value}
                    </Box>
                </Stack>
            ),
        });
        return baseColumns;
    }, [data, setData]);

    const menuItem = [
        {type: "edit", text: "Заменить", handler: openSearchSimilarMaterials},
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
        {type: "deleteReserve", text: "Удалить резервы", handler: handleDeleteReserve},
        {type: "editNote", text: "Изменить комментарий", handler: handleEditNote},
        {type: "editQuantity", text: "Изменить количество", handler: handleEditQuantity}
    ]
    const modalActions = [
        {name: "Создать резервы", type: "createReserves"},
        {name: "Удалить", type: "delete"},
        {type: "deleteReserve", name: "Удалить резервы"}
    ]

    const statusesForAddMaterial = ["IN_WORK",
        "CREATED_RESERVES",
        "PURCHASE",
        "PURCHASED",
        "SHIPMENT"]
    const addMaterialDisabled = (selectData.cost === 1 && estimateState !== "CALCULATION") || (selectData.cost === 2 && !statusesForAddMaterial.includes(estimateState))

    return (
        <Box sx={{maxWidth: "2500px"}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", gap: "10px", paddingBottom: "30px"}}
            >
                <ButtonCreate
                    tooltip={"Материалы в которых созданы резервы игнорируются"}
                    text={"Создать резервы"}
                    width={210}
                    onClick={() => setCreateReservesModalOpen(true)}
                    // disabled={estimateState !== 'IN_WORK' || addMaterialDisabled || !availableAddReserve || rowSelection.length > 0}
                />

                <ButtonCreate
                    text={"Добавить материал"}
                    width={210}
                    onClick={() => setMaterialModal(true)}
                    disabled={addMaterialDisabled}
                />
                {isButtonPurchase === 'true' &&
                    <ButtonCreate
                        text={"Подать заявку на закупку"}
                        width={210}
                        onClick={() => setSetPurchaseModalOpen(true)}
                        disabled={!currentInWork}
                    />}
                {(isFact && errorIds?.isFact?.length > 0 || !isFact && errorIds?.isCalc?.length > 0) && <Button
                    size="small"
                    color="secondary"
                    variant="contained"
                    sx={{
                        animation: 'blinking 1s infinite',
                        WebkitAnimation: 'blinking 1s infinite',
                        '@keyframes blinking': {
                            '0%': {backgroundColor: '#fff'},
                            '50%': {backgroundColor: '#f00'},
                            '100%': {backgroundColor: '#fff'},
                        },
                    }}
                >
                    Наименования одинаковые
                </Button>}
            </Box>
            <Box sx={{overflow: 'auto'}}>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    muiTopToolbarProps={{
                        sx: {
                            "& .MuiBox-root": {
                                padding: 0
                            }
                        }
                    }}
                    muiTableBodyCellProps={({cell, table}) => {
                        const errorRow = DetailUtil.isDuplicateEstimateRow(errorIds, isFact, cell.row.original.id)
                        return ({
                            sx: {
                                p: '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",
                                backgroundColor: errorRow ? "red !important" : undefined,
                                "&:after": {
                                    display: "none",
                                },
                                "& td:after": {
                                    "&:hover": {
                                        backgroundColor: "red"
                                    }
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& a": {
                                    color: errorRow ? "white" : "#006CCC",
                                    textDecoration: "none",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }

                                }
                            },
                        })
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        const errorRow = DetailUtil.isDuplicateEstimateRow(errorIds, isFact, row.original.id)
                        return ({
                            sx: (theme) => ({
                                height: '36px',
                                backgroundColor: errorRow ? "red" : "white",
                                "& td": errorRow ? {backgroundColor: "red !important"} : undefined,
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: errorRow ? "red" : theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: errorRow ? "red" : theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: errorRow ? "red" : theme.palette.primary.stroke,
                                    ...(errorRow ? {"& td": {backgroundColor: "red !important"}} : {}),
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: errorRow ? "red" : theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: errorRow ? "red" : theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: errorRow ? "red" : theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: errorRow ? "red" : theme.palette.primary.stroke,
                                    },
                                    ...(errorRow ? {"& td": {backgroundColor: "red !important"}} : {}),
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: "",
                            size: 3,
                            minSize: 3,
                            grow: false,
                        },
                        'mrt-row-select': {
                            size: "50px",
                            grow: false,
                        },
                    }}
                    columns={columns}
                    data={filteredData}
                    onRowSelectionChange={onRowSelectionChange}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={setGlobalFilter}
                    globalFilterFn={ESTIMATE_GLOBAL_FILTER_FN}
                    filterFns={estimateFilterFns}
                    getColumnCanGlobalFilter={estimateGetColumnCanGlobalFilter}
                    enableGlobalFilterRankedResults={false}
                    state={{
                        rowSelection: currentSelection,
                        showGlobalFilter: true,
                        pagination: tableOptions,
                        globalFilter,
                    }}
                    rowCount={filteredData.length}
                    enableRowSelection={true}
                    getRowId={(originalRow) => originalRow.id}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    initialState={{
                        columnVisibility: {
                            id: false,
                            model: false,
                            year: false,
                        },
                        sorting: [{id: 'unit', desc: false}],
                    }}
                    localization={MRT_Localization_RU}
                    enableRowActions={true}
                    enableToolbarInternalActions={false}
                    selectAllMode={"all"}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}
                    muiTableContainerProps={{
                        sx: {
                            maxHeight: rowSelection?.length > 0 ? `calc(100vh - 750px)` : `calc(100vh - 670px)`,
                            width: "2500px"
                        }
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        const disabled = (row.original.workingCuttingMapId || (row.original.isBlocked && el.type !== "deleteReserve")) && el.type !== "editNote"
                        return <Tooltip arrow placement="left"
                                        title={disabled ? "Материал заблокирован" : ""}>
                            <MenuItem
                                key={el.type}

                                onClick={() => {
                                    !disabled && el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    opacity: disabled && 0.5,
                                    "&:hover": {backgroundColor: disabled ? "transparent" : (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        </Tooltip>
                    })}
                />
            </Box>
            <ModalWidthCheckbox
                open={setPurchaseModalOpen}
                onClose={handleCloseSetPurchase}
                handleSubmit={(ignoreSlab, handleClose) => handleSubmitSetPurchase(ignoreSlab, handleClose)}
                title={"Подтвердить создание заявки на закупку?"}
                action={"Подтвердить"}
                loading={loading}/>

            {currentEditRowData?.id ? <ReplacementSimilarMaterials
                open={searchSimilarMaterials}
                setOpen={setSearchSimilarMaterials}
                replacement={replacement}
                currentEditRowData={currentMaterialData}
                setCurrentEditRowData={setCurrentMaterialData}
                id={currentEditRowData.id}
                handleModalAlert={handleModalAlert}
                loading={loading}
            /> : ""}
            <ModalWidthCheckbox
                open={createReservesModalOpen}
                onClose={() => setCreateReservesModalOpen(false)}
                handleSubmit={(ignoreSlab, handleClose) => handleShowReservesModal(true, null, ignoreSlab, handleClose)}
                title={"Подтвердить создание резервов?"}
                action={"Подтвердить"}
                loading={loading}/>

            <ModalConfirm
                title={"Вы действительно хотите удалить резервы?"}
                modalOpen={showReservesModal}
                handleClose={closeShowReservesModal}
                handleSubmit={() => handleShowReservesModal(true)}
                action={'Удалить'}
                loading={loading}
            />
            <ModalAddMaterial
                open={materialModal}
                title={"Добавить материал"}
                initValue={currentEditRowData}
                onClose={handleCloseMaterialModal}
                handleSubmit={handleSubmit}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpenSelection(true)}/>
            </Paper>}
            <ModalSelectAction
                open={openSelection}
                reset={() => setOpenSelection(false)}
                submit={(action, ignoreSlab, handleCancel) => handleShowReservesModal(false, action, ignoreSlab, handleCancel)}
                modalActions={modalActions}
                ignoreSlab={true}
                ignoreTypes={["createReserves"]}
                loading={loading}
            />
            <ModalEdit
                open={openEdit} editModalData={editModalData} onClose={onCloseEditModal}
                onSubmit={onSubmitEditModal}
                loading={loading}/>
        </Box>
    );
};
const ModalEdit = ({open, editModalData, onClose, onSubmit, loading}) => {
    const [formState, setFormState] = useState(editModalData.value)
    useEffect(() => {
        setFormState(editModalData.value)
    }, [open]);

    return <Dialog open={open} PaperProps={{
        style: {
            minWidth: "400px",
        }
    }}>

        <DialogTitle
            textAlign="center">{editModalData.type === "note" ? "Изменить комментарий" : "Изменить количество"}</DialogTitle>
        <DialogContent>
            {editModalData.type === "note" ? <TextFieldValidation
                name={"note"}
                value={formState?.note}
                label="Комментарий"
                setCurrValues={setFormState}
            /> : <TextFieldValidation
                name={"quantity"}
                value={formState?.quantity}
                label="Количество"
                type={"number"}
                setCurrValues={setFormState}
            />}
        </DialogContent>
        <DialogActions sx={{p: '1.25rem'}}>
            <ButtonExit text={"Выйти"} onClick={onClose}/>
            <ButtonAdd loading={loading} text={"Изменить"}
                       onClick={() => onSubmit({...editModalData, value: formState})}/>
        </DialogActions>
    </Dialog>
}

export default EstimateTableItem;

